import React, { Component } from 'react';
import Nav from '../../components/nav/Nav';
import Footer from '../../components/footer/Footer';
import PrivacyPolicyBanner from '../../components/banner/PrivacyPolicyBanner';
import PrivacyPolicyMain from '../../components/main/PrivacyPolicyMain';
import PrivacyPolicyPart2Main from '../../components/main/PrivacyPolicyPart2Main';



class PrivacyPolicy extends Component {
  render() {
    return (
      <div>
        <Nav></Nav>
        <PrivacyPolicyBanner></PrivacyPolicyBanner>
        <PrivacyPolicyMain></PrivacyPolicyMain>
        <PrivacyPolicyPart2Main></PrivacyPolicyPart2Main>
        <Footer></Footer>
      </div>
    )
  }
}

export default PrivacyPolicy
